import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { HeaderImpl } from "./header.styles.es.js";
const propTypes = {
  border: PropTypes.bool,
  children: PropTypes.node.isRequired,
  shadow: PropTypes.bool
};
const defaultProps = {
  border: false,
  shadow: false
};
const Header = ({ border, children, shadow }) => /* @__PURE__ */ jsx(HeaderImpl, { $border: border, $shadow: shadow, children });
Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
export {
  Header
};
